<template>
  <b-card no-body class="wrapper" v-if="lookups">
    <b-card-body>
      <b-card-text>
        <div class="label">Not Interested Reason</div>
        <div class="text">
          <b-form-select
            id="answer"
            v-model="selectedReason"
            :options="notInterestedReasons"
            value-field="id"
            text-field="name"
          >
          </b-form-select>
        </div>

        <div v-if="selectedReason == otherId">
          <div class="label">Other Reason</div>
          <div class="text">
            <b-form-textarea id="other" v-model="notInterestedReasonOther">
            </b-form-textarea>
          </div>
        </div>

        <div v-if="selectedReason == otherIdAdvisor">
          <div class="label">Name of Advisor</div>
          <div class="text">
            <b-form-textarea id="notInterestedOtherAdvisor" v-model="notInterestedOtherAdvisor">
            </b-form-textarea>
          </div>
        </div>
        <div v-if="selectedReason == otherIdAdvisor">
          <div class="label">Contract End Date</div>
          <b-form-datepicker :id="'notInterestedOtherAdvisorContractEndDate' "
              :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
            locale="en-GB"
            v-model="notInterestedOtherAdvisorContractEndDate">
            </b-form-datepicker>
        </div>
        <div class="text">
          <b-button class="mt-3" variant="success" block @click="saveReason" :disabled="!selectedReason">
            <font-awesome-icon icon="check" /> Confirm
          </b-button>

          <b-button
            class="mt-3"
            variant="danger"
            block
            @click="$parent.showDispositions">
            <font-awesome-icon icon="times" /> Cancel
          </b-button>
        </div>
      </b-card-text>
    </b-card-body>
  </b-card>
</template>

<script>
import DataSelectionService from "@/services/DataSelection.service";

export default {
  name: "NotInterestedReason",
  props: {
    companyId: String,
    lookups: Object
  },
  data() {
    return {
      selectedReason: null,
      notInterestedReasonOther: null,
      notInterestedOtherAdvisor: null,
      notInterestedOtherAdvisorContractEndDate: null,
      otherId: 900,
      otherIdAdvisor : 80
    };
  },
  computed: {
    notInterestedReasons() {
      if (!this.lookups && this.lookups.notInterestedReasons) return [];

      var array = [...this.lookups.notInterestedReasons];

      if (array[0].id == 0) {
        array[0].disabled = true
      }

      return array;
    }
  },
  methods: {
    saveReason() {

      this.$http.post("/company/notinterested/",
        {
          companyId: this.companyId,
          notInterestedReasonId: this.selectedReason,
          notInterestedReasonOther: this.notInterestedReasonOther,
          notInterestedOtherAdvisor: this.notInterestedOtherAdvisor,
          notInterestedOtherAdvisorContractEndDate: this.notInterestedOtherAdvisorContractEndDate
        }).then(() => {
          if(this.$route.name == "CompanyCall") {
            DataSelectionService.getNextCompany().then(result => {
              if(result && result.data != 0) {
                this.$router.push("/call/" + result.data);
              } else {
                this.$router.push("/getnext");
              }
            });
          } else {
            this.$parent.$parent.loadData();
            this.$parent.showDispositions();
          }
      });
    },
  },
};
</script>

<style scoped>
.label {
  font-weight: 600;
}
.text {
  margin-bottom: 10px;
}
.wrapper {
  margin-top: 10px;
}
</style>
